import type { RefObject } from "react";
import { useEffect, useState } from "react";
import { AFTER_CONTAINER_HOVER_OFFSET_PX } from "../utils/constants";

export function useHoverBelowNavigation(containerRef: RefObject<HTMLDivElement | null>) {
	const [isHoverBelow, setIsHoverBelow] = useState(false);

	useEffect(() => {
		const container = containerRef.current;
		const leftNavigationContent = container?.closest<HTMLElement>(".left-navigation-content");
		if (!container || !leftNavigationContent) return;

		let frameId: number | null = null;
		let clientX = 0;
		let clientY = 0;

		const onPointerMove = (e: PointerEvent) => {
			clientX = e.clientX;
			clientY = e.clientY;
			if (frameId !== null) return;

			frameId = requestAnimationFrame(() => {
				frameId = null;
				const containerRect = container.getBoundingClientRect();
				const panelRect = leftNavigationContent.getBoundingClientRect();
				const nextIsHoverBelow =
					clientY >= containerRect.bottom + AFTER_CONTAINER_HOVER_OFFSET_PX &&
					clientY <= panelRect.bottom &&
					clientX >= panelRect.left &&
					clientX <= panelRect.right;

				setIsHoverBelow((current) => (current === nextIsHoverBelow ? current : nextIsHoverBelow));
			});
		};
		const onPointerLeave = () => {
			if (frameId !== null) cancelAnimationFrame(frameId);
			frameId = null;
			setIsHoverBelow(false);
		};

		leftNavigationContent.addEventListener("pointermove", onPointerMove);
		leftNavigationContent.addEventListener("pointerleave", onPointerLeave);

		return () => {
			if (frameId !== null) cancelAnimationFrame(frameId);
			leftNavigationContent.removeEventListener("pointermove", onPointerMove);
			leftNavigationContent.removeEventListener("pointerleave", onPointerLeave);
		};
	}, [containerRef]);

	return { isHoverBelow };
}
